import * as React from "react";
import type { SVGProps } from "react";
const SvgLayoutScale = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M3 13.2h6.224c.87 0 1.575.705 1.575 1.575V21M21.6 18V6A3.6 3.6 0 0 0 18 2.4H6A3.6 3.6 0 0 0 2.4 6v12A3.6 3.6 0 0 0 6 21.6h12a3.6 3.6 0 0 0 3.6-3.6Z"
    />
  </svg>
);
export default SvgLayoutScale;
